module.exports = __webpack_public_path__ + "static/img/diu_white.1dbb7c9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/diu_white.png
// module id = HILI
// module chunks = 1